module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('span', {
    attrs: {
      "id": "Page_vii",
      "title": "[vii]"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "nobreak",
    attrs: {
      "id": "pgepubid00002"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', {
    staticClass: "calibre8",
    attrs: {
      "summary": ""
    }
  }, [_c('tbody', {
    staticClass: "calibre9"
  }, [_c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr",
    attrs: {
      "colspan": "2"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("PAGE")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Homestead in the Clearing")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0006#Page_1"
    }
  }, [_vm._v("       1")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("White Buffalo Brings News")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0007#Page_10"
    }
  }, [_vm._v("         10")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("In the Forest")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0008#Page_21"
    }
  }, [_vm._v("                    21")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Deer Shooting by Moonlight")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Section0009#Page_31"
    }
  }, [_vm._v("        31")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("An Unexpected Meeting")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0010#Page_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("             41")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("George Washington the Surveyor")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0011#Page_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      54")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Camp in the Mountain Gap")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0012#Page_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("       64")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("On to Annapolis")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0013#Page_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("                   74")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Storm in the Mountains")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0014#Page_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("            83")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("X.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("An Unsuccessful Mission")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0015#Page_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("              93")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Dave Becomes Washington’s Assistant")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0016#Page_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("       102")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Surveying Along the Shenandoah")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0017#Page_111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("           111")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("A Bear Hunt")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0018#Page_119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("                      119")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Home Coming in the Snow")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0019#Page_129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("           129")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Situation Between the English, French, and Indians")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0020#Page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("  138")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Dave’s Departure for the West")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0021#Page_146",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("       146")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Carried Down the River")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0022#Page_154",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("           154")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Dave Visits an Indian Village")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0023#Page_163",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("       163")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Trading-Post on the Kinotah")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0024#Page_172",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("       172")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("An Alarming Discovery")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0025#Page_181",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("                  181")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Defence of the Trading-Post")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0026#Page_191",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("       191")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Washington’s Mission to French Creek")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0027#Page_201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("       201")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("An Indian’s Treachery")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0028#Page_210",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      210")]), _c('span', {
    attrs: {
      "id": "Page_viii",
      "title": "[viii]"
    }
  })])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Washington at Will’s Creek")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0029#Page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      219")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXV.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Soldiers of the Wilderness")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0030#Page_229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      229")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Retreat to Fort Necessity")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0031#Page_239",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      239")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Battle at Great Meadows")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0032#Page_249",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      249")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXVIII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("The Fall of the Trading-Post")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0033#Page_259",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("     259")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXIX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Braddock’s Defeat and Fall")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0034#Page_268",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      268")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXX.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Fighting in the Forest")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0035#Page_278",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      278")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXI.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Father and Son")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0036#Page_286",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      286")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre10"
  }, [_c('td', {
    staticClass: "tdr"
  }, [_vm._v("XXXII.")]), _vm._v(" "), _c('td', {
    staticClass: "calibre13"
  }, [_c('span', {
    staticClass: "smcap"
  }, [_vm._v("Back to the Homestead—Conclusion")])]), _vm._v(" "), _c('td', {
    staticClass: "tdr"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Section0037#Page_295",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("      295")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5ff7c0e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0004.vue
// module id = 66
// module chunks = 0